export default "__VITE_ASSET__T1KZRskQ__"